import React, { Component } from 'react'
import firebase from './Firebase'
import Loader from 'react-loader';
import pdfFile from '../static/RealisedRateTermsAndConditions.pdf';
import { connect } from 'react-redux';
import { LOGIN_APPROVED } from '../constants/actionTypes';
import ReCaptcha from 'react-google-recaptcha'
import * as utils from '../util';

const mapStateToProps = state => {
    return {
        fbToken: state.common.fbToken
    }
};

const mapDispatchToProps = dispatch => ({
    onLoginApprove: (fbToken) => dispatch({ type: LOGIN_APPROVED, payload: fbToken }),
});

let recaptchaInstance;

class Register extends Component {

    constructor(props) {
        super(props)

        this.state = {
            email: '',
            password: '',
            confirmPassword: '',
            submitted: false,
            loading: false,
            accept: false,
            emailVerificationSent: false,
            showAlert: false,
            alertMessage: '',
            error: '',
            loadSpinner: false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleCheckClick = () => {
        this.setState(prevState => ({ accept: !prevState.accept }));
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { email, password, confirmPassword, accept } = this.state;
        // stop here if form is invalid
        if (!(email && password && confirmPassword) || !accept) {
            return
        }

        if (password !== confirmPassword) {
            this.setState({ alertMessage: 'Password & Confirm Password are not same.', showAlert: true })
            return
        }

        if(window.grecaptcha.getResponse().length == 0) {
            this.setState({ alertMessage: 'Please select CAPTCHA.', showAlert: true })
            return            
        }

        this.setState({ loadSpinner: true });
        firebase.auth().createUserWithEmailAndPassword(email, password).then(user => {
            var currentUser = firebase.auth().currentUser;
            currentUser.getIdToken().then((data) => {
                const fbToken = data;
                this.props.onLoginApprove(fbToken);
            currentUser.sendEmailVerification().then(() => {
                const currentTime = new Date().getTime();
                localStorage.setItem("rfr_emvts", currentTime)
                this.setState({ emailVerificationSent: true, loadSpinner: false });
            });
            });
        }).catch(error => {
            this.setState({ loadSpinner: false, alertMessage: error.message, showAlert: true })
        });
    }

    continue = () => {
        this.props.history.push("/");
    }

    onSignInClick = () => {
        this.props.history.push('/SignIn');
      }

    // verifyCallback = (recaptchaToken) => {
    //   // Here you will get the final recaptchaToken!!!  
    //   alert(recaptchaToken, "<= your recaptcha token")
    // }      
    
     render() {


        const { email, password, confirmPassword, submitted, accept, emailVerificationSent, showAlert, alertMessage, error, loadSpinner } = this.state;
        return (
            <div className="login-register-page container page">
                <div className="row form-container">
                    <div className={"col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-6 col-sm-6 col-sm-offset-6 col-xs-8 form-center form-box" + (emailVerificationSent ? " hide" : " show")}>
                        <div className={"alert alert-danger text-center" + (showAlert ? " show" : " hide")}>{alertMessage}</div>
                        <h5 className="text-center">Register</h5>
                        <div className="form-box-licence">
                            <p className="p-mb-mt">In order to view the latest published SONIA rate it is necessary to agree to the Bank of England’s licencing terms.  To do this please register with your email address and accept the terms on the link below. There is no cost associated with this registration and your details will not be released to any third parties. For more information on publication of SONIA see the <a href="https://www.bankofengland.co.uk/markets/sonia-benchmark/sonia-key-features-and-policies" target='_blank' rel="noopener noreferrer" title="https://www.bankofengland.co.uk/markets/sonia-benchmark/sonia-key-features-and-policies">BoE website</a></p> 
                        </div>
                        <form name="form" className="mt-2" onSubmit={this.handleSubmit} >
                            <div className={'form-group' + (submitted && !email ? ' has-error' : '')}>
                                <h6>Email</h6>
                                <input type="email" className="form-control" name="email" value={email} onChange={this.handleChange} />
                                {submitted && !email &&
                                    <div className="help-block">Email is required</div>
                                }
                            </div>
                            <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                                <h6>Password</h6>
                                <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} minlength="6" placeholder="At least 6 characters" />
                                {submitted && !password &&
                                    <div className="help-block">Password is required</div>
                                }
                            </div>

                            <div className={'form-group' + (submitted && !confirmPassword ? ' has-error' : '')}>
                                <h6>Confirm Password</h6>
                                <input type="password" className="form-control" name="confirmPassword" value={confirmPassword} onChange={this.handleChange} minlength="6" placeholder="At least 6 characters" />
                                {submitted && !confirmPassword && <div className="help-block">Confirm Password is required</div>}
                            </div>
                            <div className={'form-group' + (submitted && !accept ? ' has-error' : '')}>
                                <input type="checkbox" checked={this.state.checked} name="accept" onChange={this.handleCheckClick} />
                                {} I accept the <a href={pdfFile} target='_blank' rel="noopener noreferrer">Terms & Conditions</a>
                                {submitted && !accept && <div className="help-block">Please Accept Terms & Conditions</div>}
                            </div>
                            <ReCaptcha ref={e => recaptchaInstance = e}  render="explicit" sitekey={utils.captcha_site_key}/>
                            <br/>
                            <div className="text-xs-center">
                                {loadSpinner && <Loader className="loader" color='#6f2c91' scale='0.48' loaded={false} />}
                                <button className="btn btn-primary btn-block" disabled={loadSpinner}>Register</button>
                            </div>
                            {error && <div className={'alert alert-danger'}>{error}</div>}
                            <br />

                            <p className="already-register">Already Registered? <a onClick={this.onSignInClick} title='Sign-in to view latest data'>Sign-in</a></p>                            
                            
                            {/* <div className="form-box-licence">
                                <p className="p-zero-margin-bottom">As per the Bank of England licencing you need to Register / Sing-in to view the latest data, there is no cost involved, its simply in place to meet the BOE licencing requirement.</p>
                            </div> */}
                        </form>
                    </div>
                    <div className={"col-lg-4 col-lg-offset-4 col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-6 col-xs-8 form-center form-box" + (emailVerificationSent ? " show" : " hide")}>
                        <form name="form" className="mt-2" onSubmit={this.handleSubmit} >
                            <div className="form-group">
                                <h6>Verification email sent</h6>
                                <p className="break-line">A link has been sent to <strong>{email}</strong> for email verification. Please click the link in the email within 24 hrs to complete registration otherwise you will be asked to Sign-in again.<br /><br /> Press continue to view latest data.</p>
                                <button className="btn btn-primary btn-block" onClick={this.continue}>Continue</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)


// WEBPACK FOOTER //
// ./src/components/Register.js